// import React from "react";

import { cacheTypes, getMethodByDispatcher, serverUrl, getheader, postMethodByDispatcher, postMethodByCallBack, getMethodByCallBack } from "../../../store/api/CommonFunctions";

export function GetAllProduct() {
  return dispatch => {
    fetch(serverUrl + "ReceptionTasksAPI/GetProductNames/")
      .then(res => res.json())
      .then(res => {
        //console.log(res);
        return dispatch({
          type: "FETCH_DATA_PRODUCT",
          data: res
        })
      }
      ).catch(err => console.error('[FETCH_DATA_PRODUCT]', err));
  };
}
export function getProductInfoBySerialOrCode(data, onProductFound) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })
    fetch(serverUrl + "api/ProductAPI/GetProductBySerialOrBarCode?serialAndBarCode=" + data, {
      headers: getheader()
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFount") {
            alert("کالایی با این مشخصات وجود ندارد");
            return;
          }
          else {
            alert("اشکال در انجام عملیات");
            console.log("[FETCH_PRODUCT_BY_QRCODE]", res);
            return;
          }
        }
        onProductFound(res);
        // dispatch({
        //   type: "FETCH_PRODUCT_BY_QRCODE",
        //   data: res
        // })
      }).catch(e => console.log("[FETCH_PRODUCT_BY_QRCODE]", e));
  }
}
export function getProductBySerialOrGuaranteeCard(data) {
  if (!data || data === '') {
    alert("مقداری برای جستجو وجود ندارد");
    return;
  }
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(serverUrl + "api/ProductAPI/GetProductBySerialOrGuaranteeCard?serialOrCardNo=" + data, {
      headers: getheader()
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFound") {
            alert("کالایی با این مشخصات وجود ندارد");
            return;
          }
          else {
            alert("اشکال در انجام عملیات");
            console.log("[FETCH_PRODUCT_BY_QRCODE]", res);
            return;
          }
        }
        dispatch({
          type: "FETCH_PRODUCT_BY_QRCODE",
          data: res
        })
      }).catch(e => console.log("[FETCH_PRODUCT_BY_QRCODE]", e));
  }
}

export function setQrPopupStatus(status) {
  return dispatch => {
    return dispatch({
      type: "SET_QRPOPUP_STATUS",
      data: status
    });
  }
}
export function setProductPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_PRODUCT_POPUP",
      data: status
    });
  }
}
export function setImagePopup(status) {
  return dispatch => {
    dispatch({
      type: "SET_IMAGE_POPUP",
      data: status
    });
  }
}
export function setDialog(status) {
  return dispatch => {
    return dispatch({
      type: "SET_DIALOG",
      data: status
    });
  }
}
export function searchProductForSelect(data) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })

    fetch(serverUrl + `api/ProductAPI/SearchProductForSelect`, {
      headers: {
        'Token': localStorage.getItem("token"),
        'Content-Type': 'application/json',
        'Data-Type': 'json'
      },
      method: "POST",
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFount") {
            alert("کالایی با این مشخصات وجود ندارد");
            res = [];
          }
          if (res === "FillSearchFields") {
            alert("کادرهای جستجو پر نشده است");
            res = [];
          }
          else if (res.Message === "Error") {
            alert("اشکال در انجام عملیات");
            console.log("[SEARCH_PRODUCT_SELECT]", res);
            res = []
          }
        }
        dispatch({
          type: "SEARCH_PRODUCT_SELECT",
          data: res
        })
      }).catch(e => {
        dispatch({
          type: "SEARCH_PRODUCT_SELECT",
          data: []
        });
        console.log("[SEARCH_PRODUCT_SELECT]", e)
      });
  }
}
export function searchUsedParts(data) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })
    fetch(serverUrl + `api/ProductAPI/SearchUsedParts`, {
      headers: {
        'Token': localStorage.getItem("token"),
        'Content-Type': 'application/json',
        'Data-Type': 'json'

      },
      method: "POST",
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFount") {
            alert("کالایی با این مشخصات وجود ندارد");
            return;
          }
          else if (res.Message === "Error") {
            alert("اشکال در انجام عملیات");
            console.log("[SEARCH_USED_PARTS]", res);
            return;
          }
        }
        dispatch({
          type: "SEARCH_USED_PARTS",
          data: res
        })
      }).catch(e => console.log("[SEARCH_USED_PARTS]", e));
  }
}
export function searchProducts4Invoice(data, invoiceType) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })
    fetch(serverUrl + `api/ProductAPI/SearchProducts4Invoice?invoiceType=${invoiceType}`, {
      headers: {
        'Token': localStorage.getItem("token"),
        'Content-Type': 'application/json',
        'Data-Type': 'json'

      },
      method: "POST",
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFount") {
            alert("کالایی با این مشخصات وجود ندارد");
            return;
          }
          else if (res.Message === "Error") {
            alert("اشکال در انجام عملیات");
            console.log("[SEARCH_PURCHACE_PRODUCTS]", res);
            return;
          }
        }
        dispatch({
          type: "SEARCH_PURCHACE_PRODUCTS",
          data: res
        })
      }).catch(e => console.log("[SEARCH_PURCHACE_PRODUCTS]", e));
  }
}
export function getProductInfoFromModal(res) {
  return dispatch => dispatch({
    type: "PRODUCT_INFO_FROM_MODAL",
    data: res
  })
}
export function resetProductQRCode() {
  return dispatch => {
    return dispatch({
      type: "FETCH_PRODUCT_BY_QRCODE",
      data: ""

    });
  }
}
export function setProductBugPop(status) {
  return dispatch => {
    return dispatch({
      type: "SET_PBUG_POP",
      data: status
    });
  }
}
export function setAccessoriesPop(status) {
  return dispatch => {
    return dispatch({
      type: "SET_ACCESSORIES_POP",
      data: status
    });
  }
}
export function loadProductAccessories(data, onGetData) {
  postMethodByCallBack("api/ProductAccessoriesAPI/LoadProductAccessories", data, onGetData, "LoadProductAccessories");
}
export function deleteProductAccessory(id, onDelete) {
  postMethodByCallBack("api/ProductAccessoriesAPI/DeleteAccessory", id, onDelete, "DeleteAccessory");
}
export function addOrUpdateProductAccessory(data, onAddUpdate) {
  postMethodByCallBack("api/ProductAccessoriesAPI/AddOrUpdateAccessory", data, onAddUpdate, "AddOrUpdateAccessory");
}
export function getAllProductMainGroups() {
  return dispatch => dispatch(getMethodByDispatcher("api/ProductGroupingAPI/GetAllProductMainGroups", "GET_PRODUCT_MAINGROUPS", cacheTypes.NoCache, "دریافت گروه های کالا"));
}
/**
 * 
 * @param {int} mainGroupID 
 * @returns 
 */
export function getProductGroups(mainGroupID) {

  return dispatch => {
    if (!mainGroupID || mainGroupID === "") {
      return dispatch({
        type: "GET_PRODUCT_GROUPS",
        data: []
      })
    }
    dispatch(getMethodByDispatcher(`api/ProductGroupingAPI/GetProductGroups?mainGroupID=${mainGroupID}`, "GET_PRODUCT_GROUPS", cacheTypes.NoCache, "دریافت گروه های کالا"));
  }
}
export function getDefaultStoragesInfo() {
  return dispatch => dispatch(getMethodByDispatcher(`api/StorageAPI/GetDefaultStorageInfo`, "DEFAULT_STORAGES", cacheTypes.NoCache, "انبارهای پیش فرض"));
}

export function getAllProductTypes(onGet) {
  getMethodByCallBack("api/ProductTypeAPI/GetAllProductTypes", cacheTypes.NoCache, onGet, "GetAllProductTypes");
}